import { render } from "./ResizeBar.vue?vue&type=template&id=2b3b0116&scoped=true"
import script from "./ResizeBar.vue?vue&type=script&lang=js"
export * from "./ResizeBar.vue?vue&type=script&lang=js"

import "./ResizeBar.vue?vue&type=style&index=0&id=2b3b0116&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3b0116"]])

export default __exports__